import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, image }) {
  const { site, sitemetasettings } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        sitemetasettings: file(relativePath: {eq: "settings/settings-sitemeta.md"}) {
          id
          childMarkdownRemark {
            frontmatter {
              title
              titlecompany
              siteurl
              description
              author
              ogdescription
              ogtype
              defimage {
                childImageSharp {
                    fluid(maxWidth: 1028) {
                        ...GatsbyImageSharpFluid_withWebp 
                    }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    `
  )

  const sitemeta = sitemetasettings.childMarkdownRemark
  const metaDescription = description || sitemeta.frontmatter.description
  const metaTitle = title || sitemeta.frontmatter.title
  const metaTitleCompany = sitemeta.frontmatter.titlecompany
  const metaImage = image || sitemeta.frontmatter.defimage.publicURL
  const siteUrl = sitemeta.frontmatter.siteurl
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      titleTemplate={`%s | ${metaTitleCompany}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: `${siteUrl}`+metaImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: siteUrl+metaImage,
        }, 
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO